// extracted by mini-css-extract-plugin
module.exports = {"modal__cardBody":"elements-module--modal__card-body--hvN3W","modal__card":"elements-module--modal__card--18srS"};